'use client';
import Link from 'next/link';
import { MouseEventHandler, PropsWithChildren, useEffect, useRef, useState } from 'react';
import LoadingComp from 'aloEjare/loading/loading.index';
import { Portal } from 'react-portal';
import { nextBrowser } from 'scripts';
import { useParams, useRouter } from 'next/navigation';
import { __AppLinkPropsType } from './appLink.type';

const AppLinkComp = (props: PropsWithChildren<__AppLinkPropsType>) => {
    const searchParamsSensitive = props.searchParamsSensitive === false ? false : true;
    const [loading, setLoading] = useState(false);
    const ref = useRef<HTMLAnchorElement>(null);
    const params = useParams();
    const router = useRouter();
    const onClickHandler: MouseEventHandler<HTMLAnchorElement> = (e) => {
        if (urlDiff()) {
            e.preventDefault();
            e.stopPropagation();
            if (!props.preventReload) setLoading(true);
            router.push(props.href);
        }
    };
    const urlDiff = () => {
        if (ref.current) {
            const current = new URL(nextBrowser.window?.location.href ?? '');
            const next = new URL(ref.current.href);
            const str1 = next.protocol + next.host + next.pathname + (searchParamsSensitive ? next.search : '');
            const str2 =
                next.protocol + current.host + current.pathname + (searchParamsSensitive ? current.search : '');
            if (str1 !== str2) return true;
        }
        return false;
    };
    useEffect(() => {
        setLoading(false);
    }, [params]);
    return (
        <>
            <Link
                href={props.href}
                ref={ref}
                className={props.className}
                style={props.style}
                onClick={(e) => {
                    if (props.onClick) props.onClick(e);
                    onClickHandler(e);
                }}
                onMouseOver={props.onMouseOver}
            >
                {props.children}
            </Link>

            {loading ? (
                <Portal>
                    <LoadingComp />
                </Portal>
            ) : null}
        </>
    );
};

export default AppLinkComp;
